var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--read-only" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        !_vm.component.hideLabel
          ? _c("label", [_vm._v(_vm._s(_vm.component.label))])
          : _vm._e(),
        _c("div", { staticClass: "lead" }, [
          _c("span", { staticClass: "prefix" }, [
            _vm.value
              ? _c(
                  "svg",
                  { attrs: { width: "16", viewBox: "0 0 426.667 426.667" } },
                  [
                    _c("path", {
                      staticStyle: { fill: "#6AC259" },
                      attrs: {
                        d: "M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333\n            c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622\n            l140.894-140.898l31.309,31.309L174.199,322.918z",
                      },
                    }),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                  ]
                )
              : _c(
                  "svg",
                  { attrs: { viewBox: "0 0 27.965 27.965", width: "16" } },
                  [
                    _c("g", [
                      _c("g", { attrs: { id: "c142_x" } }, [
                        _c("path", {
                          attrs: {
                            d: "M13.98,0C6.259,0,0,6.261,0,13.983c0,7.721,6.259,13.982,13.98,13.982c7.725,0,13.985-6.262,13.985-13.982\n                C27.965,6.261,21.705,0,13.98,0z M19.992,17.769l-2.227,2.224c0,0-3.523-3.78-3.786-3.78c-0.259,0-3.783,3.78-3.783,3.78\n                l-2.228-2.224c0,0,3.784-3.472,3.784-3.781c0-0.314-3.784-3.787-3.784-3.787l2.228-2.229c0,0,3.553,3.782,3.783,3.782\n                c0.232,0,3.786-3.782,3.786-3.782l2.227,2.229c0,0-3.785,3.523-3.785,3.787C16.207,14.239,19.992,17.769,19.992,17.769z",
                            fill: "#D80027",
                          },
                        }),
                      ]),
                      _c("g", { attrs: { id: "Capa_1_104_" } }),
                    ]),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                    _c("g"),
                  ]
                ),
          ]),
          _c("span", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.component.data.textValue)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }